import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Errored from '../../core/Errored';
import { makeCancelable, sortByProp } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import PrefixDialog from './PrefixDialog';

class Prefixes extends Component {

  constructor(props) {
    super(props);
    this.state = {
      prefixes: [],
      isLoading: true,
      isErrored: null
    };
    this.cancellable = null;
  }

  componentDidMount() {
    try {
      this.getPrefixes().promise
        .then(data => {
          GS.handle("api-prefixes");
          if (this.cancellable && this.cancellable.isCancelled()) return;
          this.setState({ prefixes: data });
        })
        .catch((e) => {
          if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
        });
    }
    catch (e) {
      if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({ isErrored: e });
    }
  }

  getPrefixes() {
    this.cancellable = makeCancelable(GS.prefixes());
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  onAddPrefix = (prefix, iri) => {
    let prefixes = cloneDeep(this.state.prefixes);
    prefixes.push({
      iri: iri,
      prefix: prefix
    });
    sortByProp(prefixes, "prefix");
    this.setState({ prefixes });
  };

  clearError = () => this.setState({ isErrored: false });

  render() {

    const { classes, isReadOnly } = this.props;
    const { prefixes, isErrored } = this.state;

    if (isErrored) return <Errored dataTest="api-error" data={isErrored} clearError={this.clearError} />;

    return (
      <TitledPanel dataTest="prefixes" title="Prefixes" actions={!isReadOnly ?
        <PrefixDialog
          prefixes={prefixes}
          onAddPrefix={this.onAddPrefix} />
        :
        null}>
        <div style={{ padding: 12, backgroundColor: 'white' }}>
          <Table style={{ maxWidth: '100%' }}>
            <TableHead>
              <TableRow data-test="headers">
                <TableCell component="th" className={classes.tableHeading}>Prefix</TableCell>
                <TableCell component="th" className={classes.tableHeading}>Full IRI</TableCell>
              </TableRow>
            </TableHead>
            <TableBody data-test="prefix-list">
              {
                prefixes.map((prefixInfo, index) => {
                  return <TableRow key={index} data-test={"row-" + index} classes={{
                    root: classes.stripedRow
                  }}>
                    <TableCell data-test="prefix-text" component="td" className={classes.tableCell}>
                      <Chip
                        data-test={"prefix-" + prefixInfo.prefix}
                        color="primary"
                        clickable={false}
                        label={prefixInfo.prefix}
                        className={classes.chip}
                        style={{ margin: 0 }}
                      />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <div style={{ paddingTop: 4 }}>
                        <Typography data-test={"iri-text-" + prefixInfo.prefix} variant="body2" className={classes.tableCellText}>{prefixInfo.iri}</Typography>
                      </div>
                    </TableCell>
                  </TableRow>;
                })
              }
            </TableBody>
          </Table>
        </div>
      </TitledPanel>
    );
  }
}

Prefixes.defaultProps = {
  isReadOnly: true
};

Prefixes.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Prefixes);